import { Gender } from 'common/dto-types/team-dto';

const GenderCell = ({ value }: { value: number }): JSX.Element => {
    switch (value) {
        case Gender.Male:
            return <p>Male</p>;
        case Gender.Female:
            return <p>Female</p>;
        case Gender.Unknown:
        default:
            return <p>Unknown</p>;
    }
};

export default GenderCell;
